module.exports = __webpack_public_path__ + "img/solution-big1.89fa2eff.png";